// Global
import { jsx as _jsx } from "react/jsx-runtime";
import RelatedExpertCommentsClient from './RelatedExpertCommentsClient';
import scConfig from 'sitecore.config';
import { fetchRelatedExpertComments } from 'lib/search/fetch-related-expert-comments';
async function getRelatedExpertCommentsServerProps(layoutData, locale) {
    const routeFields = layoutData?.sitecore?.route?.fields || {};
    const authors = routeFields?.authors ?? null;
    const authorId = authors?.[0]?.id;
    const currentItemId = layoutData?.sitecore?.route?.itemId;
    const resolvedLocale = locale ?? layoutData?.sitecore?.context?.language ?? 'en-US';
    const { news, error } = await fetchRelatedExpertComments({
        locale: resolvedLocale,
        authorId,
        currentItemId,
        rfkId: 'rfkid_reports_insights',
        defaultItemsPerPage: 4,
        sitecoreEdgeContextId: scConfig.api.edge.contextId,
        siteName: scConfig.defaultSite
    });
    return {
        staticProps: {
            initialNews: news,
            fetchError: error
        }
    };
}
// Server-safe entry point (no 'use client'). Mirrors the ArticleListing split:
// keeping `getComponentServerProps` and the Default in a server module so the
// webpack `component-props.loader` can strip the server-only export, and
// delegating rendering to a client module that reads its data from
// ComponentPropsContext via `useComponentProps(uid)` (App Router does not
// auto-inject `staticProps` into placeholder children).
export const Default = (props)=>{
    return /*#__PURE__*/ _jsx(RelatedExpertCommentsClient, {
        ...props
    });
};
